var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerOneFrame4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.975 125.387H62.9767C28.3521 125.387 0.283234 97.3179 0.283234 62.6932C0.283234 28.0686 28.3521 -0.000228882 62.9767 -0.000228882H195.021C229.237 -0.000228882 256.975 27.7374 256.975 61.9535V125.387Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.67 205.281L62.9762 205.281L0.282709 205.281C0.282712 170.657 28.3515 142.588 62.9762 142.588C97.6008 142.588 125.67 170.657 125.67 205.281Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.67 222.307L62.9762 222.307L0.282709 222.307C0.282712 256.931 28.3515 285 62.9762 285C97.6008 285 125.67 256.931 125.67 222.307Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M399.377 62.8771L336.683 62.8771L273.99 62.8771C273.99 28.2524 302.059 0.183596 336.683 0.183599C371.308 0.183602 399.377 28.2524 399.377 62.8771Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.588 148.504L194.282 148.504L256.975 148.504C256.975 183.128 228.906 211.197 194.282 211.197C159.657 211.197 131.588 183.128 131.588 148.504Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerOneFrame4);
export default __webpack_public_path__ + "static/media/CornerOneFrame4.1d992fa972a59ad155a4f0d503400192.svg";
export { ForwardRef as ReactComponent };